import React from 'react';
import {ControlledListItemType5} from '@Components/controlled-list/components/controlled-list-item-type-5';
import {useAppDispatch, useAppSelector} from '../../../../hooks';
import type {LIST_ITEM_TYPE, ListDefaultItemBaseStorage} from '../../list.types';
import {updateListItemSelectionState} from '../../list-reducer';

interface ListItemType5Props {
  id: string;
  listId: string;
}

export interface ListItemType5Storage extends ListDefaultItemBaseStorage, ListBaseItemType5Storage {
  type: LIST_ITEM_TYPE.DEFAULT_5;
}

export interface ListBaseItemType5Storage {
  pill: ListItemType5PillProps;
  additionalData?: any;
}

export interface ListItemType5PillProps {
  icon: string;
  text: string;
}

export function ListItemType5({...props}: ListItemType5Props) {
  const dispatch = useAppDispatch();
  const listItemData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListItemType5Storage;
  });

  const handleClick = () => {
    dispatch(
      updateListItemSelectionState({
        listId: props.listId,
        id: props.id,
      })
    );
    if (listItemData.onClick) {
      listItemData.onClick(props.listId, props.id);
    }
  };

  return listItemData ? (
    <ControlledListItemType5
      text={listItemData.text}
      id={listItemData.id}
      onClick={handleClick}
      className={listItemData.className}
      pill={listItemData.pill}
      isSelected={listItemData.isSelected}
    />
  ) : null;
}
